module.exports = __webpack_public_path__ + "static/media/wechat_icon.9665921b.jpg";